/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmFineTuningPause } from "../../funcs/llmFineTuningPause.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.PauseFineTuningJobRequest$inboundSchema,
};

export const tool$llmFineTuningPause: ToolDefinition<typeof args> = {
  name: "llm-fine-tuning-pause",
  description: `Pause a fine-tuning job

Pause a running fine-tuning job.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmFineTuningPause(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
